














































import { Component, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IPagination } from "@/types";
import { IOffer, IOfferListRequest } from "@/types/offer";
import { OfferListRequest } from "@/models/offer";
import List from "@/components/basic/List.vue";

@Component({
  components: {},
})
export default class extends List {
  @Action("offer/salesGetList")
  public getOfferList!: (params: IOfferListRequest) => Promise<boolean>;

  @Getter("offer/list")
  public offerList!: IOffer[];

  @Getter("offer/pagination")
  public pagination!: IPagination<IOffer>;

  @Mutation("offer/clear")
  protected clear!: () => void;

  @Prop()
  public search!: string;

  @Prop()
  public status!: number | string;

  public params = new OfferListRequest();

  public headers = [
    {
      text: "title",
      align: "start",
      value: "title",
    },
    { text: "対象", value: "member", sortable: false },
    { text: "ステータス", value: "offer_status_id" },
    { text: "報酬", value: "reward_lower", sortable: false },
    { text: "概要", value: "summary", sortable: false },
  ];

  public member_id = 0;

  public created() {
    this.member_id = Number(this.$route.params.member_id);
  }

  // override
  public async getList() {
    this.loading = true;
    this.params.search = this.search;
    if (this.status === "inprogress") {
      this.params.inprogress = true;
      this.params.status = 0;
    } else if (typeof this.status === "number") {
      this.params.inprogress = false;
      this.params.status = this.status;
    }
    if (this.member_id) {
      this.params.member_id = this.member_id;
    }
    await this.getOfferList(this.params);
    this.loading = false;

    this.paramsToQuery();
  }

  public rowClick(offer: IOffer): void {
    if (this.member_id) {
      this.$router.push({
        name: "SalesMemberOfferDetail",
        params: {
          member_id: this.member_id.toString(),
          offer_id: offer.id.toString(),
        },
      });
    } else {
      this.$router.push({
        name: "SalesOfferDetail",
        params: { offer_id: offer.id.toString() },
      });
    }
  }
}
